// Dependencies
import React, { Component } from 'react';
import image from '../assets/banner/proyectos.jpg';
import Section from '../layout/Section';
import proyectos from '../assets/data/proyectos.json';
import SectionContainer from '../subcomponents/SectionContainer';
import { withRouter } from 'react-router';
import ProyectoDetalle from '../subcomponents/ProyectoDetalle';

class DetalleProyecto extends Component {
  constructor(props) {
    super(props);

    this.state = {
      proyecto: null,
      loading: true
    };
  }

  componentWillMount() {
    let proyecto = proyectos.find(item => item.slug === this.props.match.params.slug);
    document.title = 'Proyecto ' + proyecto.name + ' - Insacom';
    this.setState({
      proyecto: proyecto,
      loading: false
    });
  }
  render() {
    return (
      <Section no-contact banner={image} blur={true} bannerTitle={this.state.proyecto.name} bannerContent={this.state.proyecto.desc}>
        <SectionContainer>
          {this.state.loading ? (
            'Cargando...'
          ) : (
            <ProyectoDetalle
              images={this.state.proyecto.images}
              name={this.state.proyecto.name}
              date={this.state.proyecto.date}
              desc={this.state.proyecto.desc}
              tags={this.state.proyecto.tags}
              texto={this.state.proyecto.texto}
              hitos={this.state.proyecto.hitos}></ProyectoDetalle>
          )}
        </SectionContainer>
      </Section>
    );
  }
}

export default withRouter(DetalleProyecto);



// WEBPACK FOOTER //
// ./src/sections/DetalleProyecto.js